import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import GridContainer from './GridContainer';
import SiteFilters from '../containers/SiteFilters';
import LinkStyled from '../components/LinkStyled';
import Modal from "./Modal";
import Share from "../pages/Share";
import Search from "../pages/Search";

export default function Header( { breeds, dietaryGoals, petTypes } ) {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = (e) => {
    const close = document.querySelector(".js-modal-close");
    e.preventDefault();
    setModalOpen(true);
    setTimeout(() => close.focus(), 100);
  };

  return (
  <div className="header true-stories-header posf t0 l0 h100 w100% z3 df h-auto@sm posr@md bgc-cream-light">
    <a className="skipToMain" href="#main">Skip to main content</a>
    <GridContainer className="header__content-container h100% df jcsb aic fxdrc@sm pb16@sm">
      <a
        className="h100%"
        href="/pages/truestories"
      >
        <img
          className="header__nav-logo h100%"
          src={require('../assets/images/truestories-logo.png')}
          alt="True Stories logo"
        />
      </a>
      <SiteFilters breeds={breeds} petTypes={petTypes} dietaryGoals={dietaryGoals} className="mb10@sm mt10@sm"/>
      <LinkStyled
        className="js-modal-trigger fz12@md"
        onClick={openModal}
        href="https://www.thehonestkitchen.com/"
      >
        thehonestkitchen.com
      </LinkStyled>
      <Modal modalOpen={modalOpen} setModalOpen={setModalOpen} url="https://www.thehonestkitchen.com/" />
    </GridContainer>
  </div>
  );
}
